export default "__VITE_ASSET__Dc6dX$MS__"